import React, { createContext, useContext, useState, useCallback, useMemo } from 'react';

const LanguageContext = createContext();

const translations = {
    fr: {
        code: 'fr',
        flag: '🇫🇷',
        label: 'Francais',
        // Header
        catalogue: 'Catalogue',
        fruits: 'Fruits',
        legumes: 'Légumes',
        bio: 'Bio',
        plantes: 'Plantes',
        produitsAfricains: 'Produits Africains',
        cosmetiques: 'Cosmetiques',
        monEspace: 'Mon Espace',
        connexion: 'Connexion',
        contact: 'Nous Contacter',
        // Hero
        heroLocation: 'Marche de Rungis',
        heroTitle1: 'Le Meilleur de',
        heroTitle2: 'Rungis',
        heroTitle3: "& d'Afrique",
        heroDesc: "Grossiste en fruits, légumes, Bio, plantes & fleurs.\nDu producteur à votre commerce, sans intermédiaire — fraîcheur, qualité et prix garantis.",
        heroCtaCatalogue: 'Voir le catalogue',
        heroCtaRegister: 'Devenir client',
        clientsPro: 'Clients professionnels',
        produitsCatalogue: 'Produits au catalogue',
        delaiLivraison: 'Delai de livraison',
        // Features
        livraisonExpress: 'Livraison Express',
        livraisonExpressDesc: 'Ile-de-France en 24h',
        qualiteGarantie: 'Qualite Garantie',
        qualiteGarantieDesc: 'Produits controles',
        prixGrossiste: 'Prix Grossiste',
        prixGrossisteDesc: 'Tarifs directs Rungis',
        service7j: 'Service 7j/7',
        service7jDesc: 'Toujours disponible',
        // Seasonal
        produitsDeSaison: 'Produits de Saison',
        enSaisonEn: 'En saison en',
        produitsDisponibles: 'produits disponibles ce mois-ci',
        // Why section
        pourquoiNousChoisir: 'Pourquoi nous choisir',
        excellenceTitle: "L'excellence au service des professionnels",
        excellenceDesc: "Situes au coeur du plus grand marche de produits frais au monde, nous vous garantissons un acces privilegie aux meilleurs produits.",
        livraisonRapide: 'Livraison rapide',
        livraisonRapideDesc: 'Livraison en Ile-de-France sous 24h, directement depuis Rungis.',
        qualiteControlee: 'Qualite controlee',
        qualiteControleeDesc: 'Chaque produit est selectionne et verifie pour garantir une fraicheur optimale.',
        equipeDediee: 'Equipe dediee',
        equipeDedieeDesc: 'Une equipe de 3 professionnels a votre ecoute 7 jours sur 7.',
        // CTA
        rejoignezNous: 'Rejoignez-nous',
        pretANousRejoindre: 'Pret a nous rejoindre ?',
        ctaDesc: 'Rejoignez des centaines de professionnels qui font confiance a PRIXDEAL pour leurs approvisionnements en produits frais.',
        creerMonCompte: 'Creer mon compte',
        accederAuCatalogue: 'Acceder au catalogue',
        // Contact form
        contactTitle: 'Nous Contacter',
        contactDesc: "Une question, une demande d'information ou un besoin specifique ? N'hesitez pas a nous ecrire.",
        contactNom: 'Nom *',
        contactSociete: 'Societe',
        contactTelephone: 'Telephone',
        contactEmail: 'Email *',
        contactSujet: 'Sujet *',
        contactMessage: 'Message *',
        contactEnvoyer: 'Envoyer le message',
        contactSuccess: 'Message envoye avec succes ! Nous vous repondrons rapidement.',
        contactError: 'Erreur lors de l\'envoi. Veuillez reessayer.',
        contactNosCoordonnees: 'Nos coordonnees',
        contactNomPlaceholder: 'Votre nom complet',
        contactSocietePlaceholder: 'Nom de votre entreprise',
        contactTelPlaceholder: 'Votre numero de telephone',
        contactEmailPlaceholder: 'votre@email.com',
        contactSujetPlaceholder: 'Objet de votre message',
        contactMessagePlaceholder: 'Decrivez votre demande...',
    },
    en: {
        code: 'en',
        flag: '🇬🇧',
        label: 'English',
        catalogue: 'Catalog',
        fruits: 'Fruits',
        legumes: 'Vegetables',
        bio: 'Organic',
        plantes: 'Plants',
        produitsAfricains: 'African Products',
        cosmetiques: 'Cosmetics',
        monEspace: 'My Account',
        connexion: 'Login',
        contact: 'Contact Us',
        heroLocation: 'Rungis Market',
        heroTitle1: 'The Best of',
        heroTitle2: 'Rungis',
        heroTitle3: '& Africa',
        heroDesc: 'Wholesale fruits, vegetables, organic, plants & flowers and African products. From producer to your business, no middleman — freshness, quality and prices guaranteed.',
        heroCtaCatalogue: 'Browse catalog',
        heroCtaRegister: 'Become a client',
        clientsPro: 'Professional clients',
        produitsCatalogue: 'Products in catalog',
        delaiLivraison: 'Delivery time',
        livraisonExpress: 'Express Delivery',
        livraisonExpressDesc: 'Ile-de-France within 24h',
        qualiteGarantie: 'Guaranteed Quality',
        qualiteGarantieDesc: 'Controlled products',
        prixGrossiste: 'Wholesale Prices',
        prixGrossisteDesc: 'Direct Rungis rates',
        service7j: '7/7 Service',
        service7jDesc: 'Always available',
        produitsDeSaison: 'Seasonal Products',
        enSaisonEn: 'In season in',
        produitsDisponibles: 'products available this month',
        pourquoiNousChoisir: 'Why choose us',
        excellenceTitle: 'Excellence at the service of professionals',
        excellenceDesc: 'Located in the heart of the largest fresh produce market in the world, we guarantee you privileged access to the best products.',
        livraisonRapide: 'Fast delivery',
        livraisonRapideDesc: 'Delivery in Ile-de-France within 24h, directly from Rungis.',
        qualiteControlee: 'Controlled quality',
        qualiteControleeDesc: 'Each product is selected and verified to ensure optimal freshness.',
        equipeDediee: 'Dedicated team',
        equipeDedieeDesc: 'A team of 3 professionals at your service 7 days a week.',
        rejoignezNous: 'Join us',
        pretANousRejoindre: 'Ready to join us?',
        ctaDesc: 'Join hundreds of professionals who trust PRIXDEAL for their fresh produce supplies.',
        creerMonCompte: 'Create my account',
        accederAuCatalogue: 'Access the catalog',
        contactTitle: 'Contact Us',
        contactDesc: 'A question, a request for information or a specific need? Do not hesitate to write to us.',
        contactNom: 'Name *',
        contactSociete: 'Company',
        contactTelephone: 'Phone',
        contactEmail: 'Email *',
        contactSujet: 'Subject *',
        contactMessage: 'Message *',
        contactEnvoyer: 'Send message',
        contactSuccess: 'Message sent successfully! We will respond shortly.',
        contactError: 'Error sending message. Please try again.',
        contactNosCoordonnees: 'Our contact details',
        contactNomPlaceholder: 'Your full name',
        contactSocietePlaceholder: 'Your company name',
        contactTelPlaceholder: 'Your phone number',
        contactEmailPlaceholder: 'your@email.com',
        contactSujetPlaceholder: 'Subject of your message',
        contactMessagePlaceholder: 'Describe your request...',
    },
    it: {
        code: 'it',
        flag: '🇮🇹',
        label: 'Italiano',
        catalogue: 'Catalogo',
        fruits: 'Frutta',
        legumes: 'Verdura',
        bio: 'Biologico',
        plantes: 'Piante',
        produitsAfricains: 'Prodotti Africani',
        cosmetiques: 'Cosmetici',
        monEspace: 'Il Mio Spazio',
        connexion: 'Accesso',
        contact: 'Contattaci',
        heroLocation: 'Mercato di Rungis',
        heroTitle1: 'Il Meglio di',
        heroTitle2: 'Rungis',
        heroTitle3: "e d'Africa",
        heroDesc: "Grossista di frutta, verdura, Bio, piante & fiori e prodotti africani. Dal produttore al vostro commercio, senza intermediari — freschezza, qualità e prezzi garantiti.",
        heroCtaCatalogue: 'Sfoglia il catalogo',
        heroCtaRegister: 'Diventa cliente',
        clientsPro: 'Clienti professionali',
        produitsCatalogue: 'Prodotti nel catalogo',
        delaiLivraison: 'Tempi di consegna',
        livraisonExpress: 'Consegna Express',
        livraisonExpressDesc: 'Ile-de-France entro 24h',
        qualiteGarantie: 'Qualita Garantita',
        qualiteGarantieDesc: 'Prodotti controllati',
        prixGrossiste: 'Prezzi Ingrosso',
        prixGrossisteDesc: 'Tariffe dirette Rungis',
        service7j: 'Servizio 7/7',
        service7jDesc: 'Sempre disponibile',
        produitsDeSaison: 'Prodotti di Stagione',
        enSaisonEn: 'Di stagione a',
        produitsDisponibles: 'prodotti disponibili questo mese',
        pourquoiNousChoisir: 'Perche sceglierci',
        excellenceTitle: "L'eccellenza al servizio dei professionisti",
        excellenceDesc: "Situati nel cuore del piu grande mercato di prodotti freschi al mondo, vi garantiamo un accesso privilegiato ai migliori prodotti.",
        livraisonRapide: 'Consegna veloce',
        livraisonRapideDesc: 'Consegna in Ile-de-France entro 24h, direttamente da Rungis.',
        qualiteControlee: 'Qualita controllata',
        qualiteControleeDesc: 'Ogni prodotto e selezionato e verificato per garantire una freschezza ottimale.',
        equipeDediee: 'Team dedicato',
        equipeDedieeDesc: 'Un team di 3 professionisti al vostro servizio 7 giorni su 7.',
        rejoignezNous: 'Unisciti a noi',
        pretANousRejoindre: 'Pronto a unirti a noi?',
        ctaDesc: 'Unisciti a centinaia di professionisti che si fidano di PRIXDEAL per i loro approvvigionamenti di prodotti freschi.',
        creerMonCompte: 'Crea il mio account',
        accederAuCatalogue: 'Accedi al catalogo',
        contactTitle: 'Contattaci',
        contactDesc: 'Una domanda, una richiesta di informazioni o un bisogno specifico? Non esitate a scriverci.',
        contactNom: 'Nome *',
        contactSociete: 'Azienda',
        contactTelephone: 'Telefono',
        contactEmail: 'Email *',
        contactSujet: 'Oggetto *',
        contactMessage: 'Messaggio *',
        contactEnvoyer: 'Invia messaggio',
        contactSuccess: 'Messaggio inviato con successo! Vi risponderemo rapidamente.',
        contactError: "Errore nell'invio. Riprova.",
        contactNosCoordonnees: 'I nostri recapiti',
        contactNomPlaceholder: 'Il tuo nome completo',
        contactSocietePlaceholder: 'Nome della tua azienda',
        contactTelPlaceholder: 'Il tuo numero di telefono',
        contactEmailPlaceholder: 'tuo@email.com',
        contactSujetPlaceholder: 'Oggetto del tuo messaggio',
        contactMessagePlaceholder: 'Descrivi la tua richiesta...',
    },
    ar: {
        code: 'ar',
        flag: '🇸🇦',
        label: 'العربية',
        dir: 'rtl',
        catalogue: 'الكتالوج',
        fruits: 'فواكه',
        legumes: 'خضروات',
        bio: 'عضوي',
        plantes: 'نباتات',
        produitsAfricains: 'منتجات افريقية',
        cosmetiques: 'مستحضرات التجميل',
        monEspace: 'حسابي',
        connexion: 'تسجيل الدخول',
        contact: 'اتصل بنا',
        heroLocation: 'سوق رانجيس',
        heroTitle1: 'الافضل من',
        heroTitle2: 'رانجيس',
        heroTitle3: 'وافريقيا',
        heroDesc: 'تاجر جملة للفواكه والخضروات والعضوي والنباتات والزهور والمنتجات الأفريقية. من المنتج إلى تجارتك، بدون وسيط — نضارة وجودة وأسعار مضمونة.',
        heroCtaCatalogue: 'تصفح الكتالوج',
        heroCtaRegister: 'كن عميلا',
        clientsPro: 'عملاء محترفون',
        produitsCatalogue: 'منتج في الكتالوج',
        delaiLivraison: 'مدة التوصيل',
        livraisonExpress: 'توصيل سريع',
        livraisonExpressDesc: 'ايل دو فرانس خلال 24 ساعة',
        qualiteGarantie: 'جودة مضمونة',
        qualiteGarantieDesc: 'منتجات مراقبة',
        prixGrossiste: 'اسعار الجملة',
        prixGrossisteDesc: 'اسعار رانجيس المباشرة',
        service7j: 'خدمة 7/7',
        service7jDesc: 'متاح دائما',
        produitsDeSaison: 'منتجات الموسم',
        enSaisonEn: 'في الموسم في',
        produitsDisponibles: 'منتج متاح هذا الشهر',
        pourquoiNousChoisir: 'لماذا تختارنا',
        excellenceTitle: 'التميز في خدمة المحترفين',
        excellenceDesc: 'نقع في قلب اكبر سوق للمنتجات الطازجة في العالم، نضمن لكم وصولا مميزا لافضل المنتجات.',
        livraisonRapide: 'توصيل سريع',
        livraisonRapideDesc: 'التوصيل في ايل دو فرانس خلال 24 ساعة، مباشرة من رانجيس.',
        qualiteControlee: 'جودة مراقبة',
        qualiteControleeDesc: 'كل منتج يتم اختياره والتحقق منه لضمان نضارة مثالية.',
        equipeDediee: 'فريق مخصص',
        equipeDedieeDesc: 'فريق من 3 محترفين في خدمتكم 7 ايام في الاسبوع.',
        rejoignezNous: 'انضم الينا',
        pretANousRejoindre: 'مستعد للانضمام الينا؟',
        ctaDesc: 'انضم الى مئات المحترفين الذين يثقون في PRIXDEAL لتوريد منتجاتهم الطازجة.',
        creerMonCompte: 'انشاء حسابي',
        accederAuCatalogue: 'الوصول للكتالوج',
        contactTitle: 'اتصل بنا',
        contactDesc: 'سؤال، طلب معلومات او حاجة خاصة؟ لا تترددوا في الكتابة لنا.',
        contactNom: '* الاسم',
        contactSociete: 'الشركة',
        contactTelephone: 'الهاتف',
        contactEmail: '* البريد الالكتروني',
        contactSujet: '* الموضوع',
        contactMessage: '* الرسالة',
        contactEnvoyer: 'ارسال الرسالة',
        contactSuccess: 'تم ارسال الرسالة بنجاح! سنرد عليكم قريبا.',
        contactError: 'خطا في الارسال. يرجى المحاولة مرة اخرى.',
        contactNosCoordonnees: 'بيانات الاتصال',
        contactNomPlaceholder: 'اسمك الكامل',
        contactSocietePlaceholder: 'اسم شركتك',
        contactTelPlaceholder: 'رقم هاتفك',
        contactEmailPlaceholder: 'your@email.com',
        contactSujetPlaceholder: 'موضوع رسالتك',
        contactMessagePlaceholder: 'صف طلبك...',
    },
};

// Month names per language
const MONTHS = {
    fr: ['Janvier', 'Fevrier', 'Mars', 'Avril', 'Mai', 'Juin', 'Juillet', 'Aout', 'Septembre', 'Octobre', 'Novembre', 'Decembre'],
    en: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'],
    it: ['Gennaio', 'Febbraio', 'Marzo', 'Aprile', 'Maggio', 'Giugno', 'Luglio', 'Agosto', 'Settembre', 'Ottobre', 'Novembre', 'Dicembre'],
    ar: ['يناير', 'فبراير', 'مارس', 'ابريل', 'مايو', 'يونيو', 'يوليو', 'اغسطس', 'سبتمبر', 'اكتوبر', 'نوفمبر', 'ديسمبر'],
};

export const LANGUAGES = Object.values(translations).map(t => ({
    code: t.code,
    flag: t.flag,
    label: t.label,
}));

export const LanguageProvider = ({ children }) => {
    const [lang, setLang] = useState(() => localStorage.getItem('prixdeal_lang') || 'fr');

    const changeLang = useCallback((code) => {
        setLang(code);
        localStorage.setItem('prixdeal_lang', code);
    }, []);

    const t = translations[lang] || translations.fr;
    const monthName = useCallback((idx) => (MONTHS[lang] || MONTHS.fr)[idx] || '', [lang]);
    const isRtl = t.dir === 'rtl';

    const value = useMemo(() => ({ lang, t, changeLang, monthName, isRtl }), [lang, t, changeLang, monthName, isRtl]);

    return (
        <LanguageContext.Provider value={value}>
            {children}
        </LanguageContext.Provider>
    );
};

export const useLanguage = () => {
    const ctx = useContext(LanguageContext);
    if (!ctx) throw new Error('useLanguage must be used within LanguageProvider');
    return ctx;
};
